var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:icons' to update
import Icon from '../icon-internal';
function UiCollapse(_a) {
    var { size } = _a, restProps = __rest(_a, ["size"]);
    return (_jsxs(Icon, Object.assign({ viewBox: "0 0 18 18", size: size }, restProps, { children: [_jsx("path", { d: "M6 8V6H3v2h3Zm0 2v2H3v-2h3Z", fill: "currentColor" }), _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 2a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h12ZM9 4h6a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H9V4ZM7 14H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h4v10Z", fill: "currentColor" })] })));
}
export default UiCollapse;
